import React, { Component } from 'react';
import {
  Router,
  Route,
  Redirect
} from 'react-router-dom'
import BrowserHistory from './providers/BrowserHistory.js'

// import ConditionRoute from './ConditionRoute.js'
import GuestRoute from './common/router/GuestRoute.js'
import PrivateRoute from './common/router/PrivateRoute.js'
import Login from './components/login/Login'
import ForgotPassword from "./components/forgot-password/ForgotPassword";
import Main from './components/main/Main'

class App extends Component {
  render() {
    return (
      <div className="App">
        <Router history={BrowserHistory}>
          <div>
            <Route exact path="/" render={() => <Redirect to="/login" />} />
            <Route path="/forgot-password/:token?" component={ForgotPassword} />
            <GuestRoute path="/login" component={Login} />
            <PrivateRoute path="/main" component={Main} />
            {/* <ConditionRoute
                         path="/main"
                         condition={this.props.isAuthenticated === true}
                         redirect="/login"
                         component={Main}/> */}
          </div>
        </Router>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js